import { Navigate, Route, Routes } from "react-router-dom";
import DMSDeviceMainComponent from "src/modules/admin/components/dms/components/dms-device-main.component";
import DisplayLocationLocation from "src/modules/admin/components/location/components/display-location.component";
import VerifyMasterDataComponent from "src/modules/verify-master-data/verify-master-data.component";
import AdminComponent from "../../modules/admin/admin.component";
import ReportConfigurationComponent from "../../modules/admin/components/configuration/components/report-configuration.component";
import ConfigurationComponent from "../../modules/admin/components/configuration/configuration.component";
import DMSCertificateComponent from "../../modules/admin/components/dms/components/dms-certificate.component";
import DMSDashboardComponent from "../../modules/admin/components/dms/components/dms-dashboard.component";
import DMSDeviceDetailsComponent from "../../modules/admin/components/dms/components/dms-device-details.component";
import DMSDeviceComponent from "../../modules/admin/components/dms/components/dms-device.component";
import OTAComponent from "../../modules/admin/components/dms/components/ota.component";
import DMSComponent from "../../modules/admin/components/dms/dms.component";
import AssetModelComponent from "../../modules/admin/components/inventory/components/asset-model.component";
import InventoryAssetComponent from "../../modules/admin/components/inventory/components/asset.component";
import DriverModelComponent from "../../modules/admin/components/inventory/components/driver-model.component";
import InventoryComponent from "../../modules/admin/components/inventory/inventory.component";
import BlockComponent from "../../modules/admin/components/location/components/block.component";
import SiteComponent from "../../modules/admin/components/location/components/site.component";
import TownCouncilComponent from "../../modules/admin/components/location/components/town-council.component";
import LocationsComponent from "../../modules/admin/components/location/locations.component";
import SLSListComponent from "../../modules/admin/components/smart-light-supplier/components/sls-list.component";
import SLSComponent from "../../modules/admin/components/smart-light-supplier/sls.component";
import PendingApprovalComponent from "../../modules/admin/components/users/components/pending-approval.component";
import RoleComponent from "../../modules/admin/components/users/components/role.component";
import UserListComponent from "../../modules/admin/components/users/components/user-list.component";
import UserComponent from "../../modules/admin/components/users/users.component";
import AssetComponent from "../../modules/asset/asset.component";
import AssetActionComponent from "../../modules/asset/components/asset-action/asset-action.component";
import TriggeringZoneCommonComponent from "../../modules/asset/components/asset-action/components/common/triggering-zone.component";
import LightParametersComponent from "../../modules/asset/components/asset-action/components/light-parameters/light-parameters.component";
import { default as LightingParameterComponentForLight } from "../../modules/asset/components/asset-action/components/light-parameters/lighting-parameter.component";
import { default as SensorParameterComponentForSensor } from "../../modules/asset/components/asset-action/components/light-parameters/sensor-parameter.component";
import DaylightHarvestingComponent from "../../modules/asset/components/asset-action/components/light-profile/daylight-harvesting.component";
import OldDaylightProfileComponent from "../../modules/asset/components/asset-action/components/light-profile/daylight-profile.component";
import DimmingProfileComponent from "../../modules/asset/components/asset-action/components/light-profile/dimming-profile.component";
import LightProfileComponent from "../../modules/asset/components/asset-action/components/light-profile/light-profile.component";
import LuminanceProfileComponent from "../../modules/asset/components/asset-action/components/light-profile/luminance-profile.component";
import RainProfileComponent from "../../modules/asset/components/asset-action/components/light-profile/rain-profile.component";
import OldTimerProfileComponent from "../../modules/asset/components/asset-action/components/light-profile/timer-profile.component";
import LightingGroupComponent from "../../modules/asset/components/asset-action/components/lighting-group/lighting-group.component";
import SensorParametersComponent from "../../modules/asset/components/asset-action/components/sensor-parameters/sensor-parameters.component";
import AssetDetailPolyComponent from "../../modules/asset/components/asset-detail/asset-details.component";
import AssetMainComponent from "../../modules/asset/components/asset-main/asset-main.component";
import DashboardDetailsComponent from "../../modules/dashboard/components/dashboard-details-map-view/dashboard-details.component";
import DashboardFloorPlanComponent from "../../modules/dashboard/components/dashboard-floor-plan/dashboard-floorplan-breadcrumb-n-sidebar.component";
import DashboardFloorPlanViewComponent from "../../modules/dashboard/components/dashboard-floor-plan/dashboard-floorplan-view.component";
import DashboardMainComponent from "../../modules/dashboard/components/dashboard-main/dashboard-main.component";
import DashboardComponent from "../../modules/dashboard/dashboard.component";
import FaultComponent from "../../modules/fault/fault.component";
import LoginComponent from "../../modules/login/login.component";
import ProfilePageComponent from "../../modules/profile/profile-page.component";
import BurnTimeReportComponent from "../../modules/report/components/burn-time-report.component";
import EnergyReportComponent from "../../modules/report/components/energy-report.component";
import EnvironmentalReportComponent from "../../modules/report/components/environmental-report.component";
import FaultReportComponent from "../../modules/report/components/fault-report.component";
import MotionHeatMapReportComponent from "../../modules/report/components/motion-heat-map-report.component";
import MotionTrafficReportComponent from "../../modules/report/components/motion-traffic-report.component";
import TestReportComponent from "../../modules/report/components/test-report.component";
import UserActivityReportComponent from "../../modules/report/components/user-activity-report.component";
import ReportComponent from "../../modules/report/report.component";
import TestMainComponent from "../../modules/test/components/main/test-main.component";
import NewScheduleComponent from "../../modules/test/components/new-schedule/new-schedule.component";
import TestComponent from "../../modules/test/test.component";
import {
  AdminModules,
  AssetModules,
  DashboardModules,
  FaultModules,
  ReportModules,
  TestModules,
  UserModules,
} from "../enums/module-name-enums";
import ForbiddenComponent from "../error/forbidden.component";
import PageNotFoundComponent from "../error/page-not-found.component";
import CaseSensitiveRoute from "../guards/case-sensitive-routes";
import PrivateRoute from "../guards/private-routes";
import WithNav from "../guards/with-nav";
import WithoutNav from "../guards/without-nav";
import { OpenIdCallback } from "../openid/OpenIdCallback";
import LoginErrorComponent from "../error/loginError.component";
import AssetImportRevampComponent from "src/modules/admin/components/inventory/components/asset-import-revamp.component";
import FloorplanAnalyticsComponent from "src/modules/dashboard/components/dashboard-floor-plan/dashboard-floor-plan-analytics/floorplan-analytics.component";
import SimCardComponent from "src/modules/admin/components/dms/components/sim-card.component";
import AssetConfigurationComponent from "src/modules/asset/components/asset-detail/asset-configuration/asset-configuration.component";
import GeneralConfigurationComponent from "src/modules/asset/components/asset-detail/asset-configuration/general-configuration/general-configuration.component";
import LightGroupsComponent from "src/modules/asset/components/asset-detail/asset-configuration/light-groups/light-groups.component";
import ZonesComponent from "src/modules/asset/components/asset-detail/asset-configuration/zones/zones.component";
import AnalyticsComponent from "src/modules/dashboard/components/dashboard-floor-plan/dashboard-floor-plan-analytics/analytics.component";
import TimerProfileComponent from "src/modules/asset/components/asset-detail/asset-configuration/timer-profile/timer-profile.component";
import DaylightProfileComponent from "src/modules/asset/components/asset-detail/asset-configuration/daylight-profile/daylight-profile.component";

export default function SlaRoutes() {
  return (
    <>
      <Routes>
        {/* without navbar */}
        <Route element={<WithoutNav />}>
          {/* for oidc */}
          <Route path="/react/" element={<OpenIdCallback />} />
          <Route path="/logout-callback/" element={<Navigate to="/login" />} />
        </Route>

        {/* withnavbar */}
        <Route element={<WithNav />}>
          <Route path="login" element={<LoginComponent />} />

          <Route path="/" element={<Navigate to="/dashboard" />} />
          <Route path="/page-not-found" element={<PageNotFoundComponent />} />
          <Route path="/forbidden" element={<ForbiddenComponent />} />
          <Route path="/login-error" element={<LoginErrorComponent />} />
          <Route path="/saveAssetRevamp" element={<AssetImportRevampComponent />} />
          <Route path="/dashboard" element={<DashboardComponent />}>
            <Route
              path="/dashboard"
              element={
                <PrivateRoute
                  moduleName={DashboardModules.DASHBOARD}
                  actionName="View-Dashboard"
                >
                  <DashboardMainComponent />
                </PrivateRoute>
              }
            />
            <Route
              path="/dashboard/:blockCode"
              element={
                <PrivateRoute
                  moduleName={DashboardModules.DASHBOARD_DETAILS}
                  actionName="View-Dashboard Detail"
                >
                  <DashboardDetailsComponent />
                </PrivateRoute>
              }
            />
            <Route
              path="/dashboard/:blockCode/floorplan"
              element={
                <PrivateRoute
                  moduleName={DashboardModules.FLOOR_PLAN_DETAILS}
                  actionName="View-Floor Plan Detail"
                >
                  <DashboardFloorPlanComponent />
                </PrivateRoute>
              }
            >
              <Route
                path="/dashboard/:blockCode/floorplan/:floor"
                element={
                  <PrivateRoute
                    moduleName={DashboardModules.FLOOR_PLAN_DETAILS}
                    actionName="View-Floor Plan Detail"
                  >
                    <DashboardFloorPlanViewComponent />
                  </PrivateRoute>
                }
              />
            </Route>
            <Route
              path="/dashboard/:blockCode/floorplan/:floor/floor-analytics"
              element={
                <PrivateRoute
                  moduleName={DashboardModules.FLOOR_PLAN_DETAILS}
                  actionName="View-Floor Plan Detail"
                >
                  <FloorplanAnalyticsComponent />
                </PrivateRoute>
              }
            />
          </Route>

          <Route
            path="/asset"
            element={
              <PrivateRoute
                moduleName={AssetModules.ASSET}
                actionName="View-Asset"
              >
                <AssetComponent />
              </PrivateRoute>
            }
          >
            <Route
              path="/asset"
              element={
                <PrivateRoute
                  moduleName={AssetModules.ASSET}
                  actionName="View-Asset"
                >
                  <AssetMainComponent />
                </PrivateRoute>
              }
            />
            <Route
              path="/asset/:id"
              element={
                <PrivateRoute
                  moduleName={AssetModules.ASSET_DETAILS}
                  actionName="View-Asset Details"
                >
                  <AssetDetailPolyComponent />
                </PrivateRoute>
              }
            />
            <Route
              path="/asset/:id/configuration"
              element={<AssetConfigurationComponent />}
            >
              <Route
                path="/asset/:id/configuration/general-configuration"
                element={<GeneralConfigurationComponent />}
              >
              </Route>
              <Route
                path="/asset/:id/configuration/zones"
                element={<ZonesComponent />}
              />
              <Route
                path="/asset/:id/configuration/zones/floorplan/:blockCode/:floorCode"
                element={<AnalyticsComponent zoneSelectionMode />}
              />
              <Route
                path="/asset/:id/configuration/timer-profile"
                element={<TimerProfileComponent />}
              >
              </Route>
              <Route
                path="/asset/:id/configuration/daylight-profile"
                element={<DaylightProfileComponent />}
              >
              </Route>
              <Route
                path="/asset/:id/configuration/light-groups"
                element={<LightGroupsComponent />}
              >
              </Route>
            </Route>

            <Route
              path="/asset/:id/action"
              element={
                <PrivateRoute
                  moduleName={AssetModules.ASSET_DETAILS}
                  actionName="View-Asset Details"
                >
                  <AssetActionComponent />
                </PrivateRoute>
              }
            >
              <Route
                path="/asset/:id/action/light-parameters"
                element={
                  <PrivateRoute
                    moduleName={AssetModules.LIGHT_PARAMETERS}
                    actionName="View-Light Parameters"
                  >
                    <LightParametersComponent />
                  </PrivateRoute>
                }
              >
                <Route
                  path="/asset/:id/action/light-parameters/lighting-parameters"
                  element={
                    <PrivateRoute
                      moduleName={AssetModules.LIGHT_PARAMETER}
                      actionName="View-Light Parameter"
                    >
                      <LightingParameterComponentForLight />
                    </PrivateRoute>
                  }
                />
              </Route>

              <Route
                path="/asset/:id/action/sensor-parameters"
                element={
                  <PrivateRoute
                    moduleName={AssetModules.SENSOR_PARAMETERS}
                    actionName="View-Sensor Parameters"
                  >
                    <SensorParametersComponent />
                  </PrivateRoute>
                }
              >
                <Route
                  path="/asset/:id/action/sensor-parameters/sensor-parameter"
                  element={
                    <PrivateRoute
                      moduleName={AssetModules.SENSOR_PARAMETER}
                      actionName="View-Sensor Parameter"
                    >
                      <SensorParameterComponentForSensor />
                    </PrivateRoute>
                  }
                />
              </Route>

              <Route
                path="/asset/:id/action/triggering-zone"
                element={
                  <PrivateRoute
                    moduleName="Triggering Zone"
                    actionName="View-Triggering zone"
                  >
                    <TriggeringZoneCommonComponent />
                  </PrivateRoute>
                }
              />
              <Route
                path="/asset/:id/action/lighting-group"
                element={
                  <PrivateRoute
                    moduleName="Triggering Zone"
                    actionName="View-Triggering zone"
                  >
                    <LightingGroupComponent />
                  </PrivateRoute>
                }
              />

              <Route
                path="/asset/:id/action/light-profile"
                element={
                  <PrivateRoute
                    moduleName={AssetModules.LIGHT_PROFILE}
                    actionName="View-Light Profile"
                  >
                    <LightProfileComponent />
                  </PrivateRoute>
                }
              >
                <Route
                  path="/asset/:id/action/light-profile/timer-profile"
                  element={
                    <PrivateRoute
                      moduleName={AssetModules.TIMER_PROFILE}
                      actionName="View-Timer Profile"
                    >
                      <OldTimerProfileComponent />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/asset/:id/action/light-profile/dimming-profile"
                  element={
                    <PrivateRoute
                      moduleName={AssetModules.DIMMING_PROFILE}
                      actionName="View-Dimming Profile"
                    >
                      <DimmingProfileComponent />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/asset/:id/action/light-profile/luminance-profile"
                  element={
                    <PrivateRoute
                      moduleName={AssetModules.LUMINANCE_PROFILE}
                      actionName="View-Luminance Profile"
                    >
                      <LuminanceProfileComponent />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/asset/:id/action/light-profile/daylight-profile"
                  element={
                    <PrivateRoute
                      moduleName={AssetModules.DAYLIGHT_PROFILE}
                      actionName="View-DayLight Profile"
                    >
                      <OldDaylightProfileComponent />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/asset/:id/action/light-profile/rain-profile"
                  element={
                    <PrivateRoute
                      moduleName={AssetModules.RAIN_PROFILE}
                      actionName="View-Rain Profile"
                    >
                      <RainProfileComponent />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/asset/:id/action/light-profile/daylight-harvesting"
                  element={
                    <PrivateRoute
                      moduleName={AssetModules.DAYLIGHT_HARVESTING}
                      actionName="View-DayLight Harvesting"
                    >
                      <DaylightHarvestingComponent />
                    </PrivateRoute>
                  }
                />
              </Route>
            </Route>
          </Route>

          <Route
            path="/fault"
            element={
              <PrivateRoute
                moduleName={FaultModules.FAULT}
                actionName="View-Fault"
              >
                <FaultComponent />
              </PrivateRoute>
            }
          />

          <Route
            path="/test"
            element={
              <PrivateRoute
                moduleName={TestModules.TEST}
                actionName="View-Test"
              >
                <TestComponent />
              </PrivateRoute>
            }
          >
            <Route
              path="/test"
              element={
                <PrivateRoute
                  moduleName={TestModules.TEST}
                  actionName="View-Test"
                >
                  <TestMainComponent />
                </PrivateRoute>
              }
            />
            <Route
              path="/test/new-schedule"
              element={
                <PrivateRoute
                  moduleName={TestModules.TEST}
                  actionName="View-Test"
                >
                  <NewScheduleComponent />
                </PrivateRoute>
              }
            />
          </Route>

          <Route
            path="/report"
            element={
              <PrivateRoute
                moduleName={ReportModules.FAULT_REPORT}
                actionName="View-Fault Report"
              >
                <ReportComponent />
              </PrivateRoute>
            }
          >
            <Route
              path="/report/faultreport"
              element={
                <PrivateRoute
                  moduleName={ReportModules.FAULT_REPORT}
                  actionName="View-Fault Report"
                >
                  <FaultReportComponent />
                </PrivateRoute>
              }
            />
            <Route
              path="/report/burntimereport"
              element={
                <PrivateRoute
                  moduleName={ReportModules.BURN_TIME_REPORT}
                  actionName="View-Burn Time Report"
                >
                  <BurnTimeReportComponent />
                </PrivateRoute>
              }
            />
            <Route
              path="/report/motiontrafficreport"
              element={
                <PrivateRoute
                  moduleName={ReportModules.MOTION_TRAFFIC_REPORT}
                  actionName="View-Motion Traffic Report"
                >
                  <MotionTrafficReportComponent />
                </PrivateRoute>
              }
            />
            <Route
              path="/report/motionheatmapreport"
              element={
                <PrivateRoute
                  moduleName={ReportModules.MOTION_HEAT_MAP_REPORT}
                  actionName="View-Motion Heat Map Report"
                >
                  <MotionHeatMapReportComponent />
                </PrivateRoute>
              }
            />
            <Route
              path="/report/energyreport"
              element={
                <PrivateRoute
                  moduleName={ReportModules.ENERGY_REPORT}
                  actionName="View-Energy Report"
                >
                  <EnergyReportComponent />
                </PrivateRoute>
              }
            />
            <Route
              path="/report/testreport"
              element={
                <PrivateRoute
                  moduleName={ReportModules.TEST_REPORT}
                  actionName="View-Test Report"
                >
                  <TestReportComponent />
                </PrivateRoute>
              }
            />
            <Route
              path="/report/useractivityreport"
              element={
                <PrivateRoute
                  moduleName={ReportModules.USER_ACTIVITY_REPORT}
                  actionName="View-User Activity Report"
                >
                  <UserActivityReportComponent />
                </PrivateRoute>
              }
            />
            <Route
              path="/report/environmentalreport"
              element={
                <PrivateRoute
                  moduleName={ReportModules.ENVIRONMENTAL_REPORT}
                  actionName="View-Environmental Report"
                >
                  <EnvironmentalReportComponent />
                </PrivateRoute>
              }
            />
          </Route>

          <Route path="/admin" element={<AdminComponent />}>
            <Route path="/admin/user" element={<UserComponent />}>
              <Route
                path="/admin/user/userList"
                element={
                  <PrivateRoute
                    moduleName={AdminModules.USERS}
                    actionName="View-Users"
                  >
                    <UserListComponent />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin/user/pendingapproval"
                element={
                  <PrivateRoute
                    moduleName={AdminModules.PENDING_APPROVAL}
                    actionName="View-Pending Approval"
                  >
                    <PendingApprovalComponent />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin/user/role"
                element={
                  <PrivateRoute
                    moduleName={AdminModules.ROLE}
                    actionName="View-Role"
                  >
                    <RoleComponent />
                  </PrivateRoute>
                }
              />
              {/* <Route
                path="/admin/user/accessmapping"
                element={
                  <PrivateRoute
                    moduleName={AdminModules.ACCESS_MAPPING}
                    actionName="View-Access Mapping"
                  >
                    <AccessMappingMainComponent />
                  </PrivateRoute>
                }
              /> */}
            </Route>

            <Route path="/admin/smarlightsupplier" element={<SLSComponent />}>
              <Route
                path="/admin/smarlightsupplier/supplierlist"
                element={
                  <PrivateRoute
                    moduleName={AdminModules.SUPPLIER_LIST}
                    actionName="View-Supplier List"
                  >
                    <SLSListComponent />
                  </PrivateRoute>
                }
              />
            </Route>

            <Route path="/admin/location" element={<LocationsComponent />}>
              <Route
                path="/admin/location/towncouncil"
                element={
                  <PrivateRoute
                    moduleName={AdminModules.TOWN_COUNCIL}
                    actionName="View-Town Council"
                  >
                    <TownCouncilComponent />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin/location/site"
                element={
                  <PrivateRoute
                    moduleName={AdminModules.SITE}
                    actionName="View-Site"
                  >
                    <SiteComponent />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin/location/block"
                element={
                  <PrivateRoute
                    moduleName={AdminModules.BLOCK}
                    actionName="View-Block"
                  >
                    <BlockComponent />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin/location/displaylocation"
                element={
                  <PrivateRoute
                    moduleName={AdminModules.Location}
                    actionName="View-Location"
                  >
                    <DisplayLocationLocation />
                  </PrivateRoute>
                }
              />
            </Route>
            <Route path="/admin/inventory" element={<InventoryComponent />}>
              <Route
                path="/admin/inventory/assetmodel"
                element={
                  <PrivateRoute
                    moduleName={AdminModules.ASSET_MODEL}
                    actionName="View-Asset Model"
                  >
                    <AssetModelComponent />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin/inventory/drivermodel"
                element={
                  <PrivateRoute
                    moduleName={AdminModules.DRIVER_MODEL}
                    actionName="View-Driver Model"
                  >
                    <DriverModelComponent />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin/inventory/asset"
                element={
                  <PrivateRoute
                    moduleName={AdminModules.ASSET}
                    actionName="View-Asset"
                  >
                    <InventoryAssetComponent />
                  </PrivateRoute>
                }
              />
            </Route>

            <Route path="/admin/dms" element={<DMSComponent />}>
              <Route
                path="/admin/dms/dashboard"
                element={
                  <PrivateRoute
                    moduleName={AdminModules.DASHBOARD}
                    actionName="View-Dashboard"
                  >
                    <DMSDashboardComponent />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin/dms/device"
                element={
                  <PrivateRoute
                    moduleName={AdminModules.DEVICE}
                    actionName="View-Device"
                  >
                    <DMSDeviceMainComponent />
                  </PrivateRoute>
                }
              >
                <Route
                  path="/admin/dms/device"
                  element={
                    <PrivateRoute
                      moduleName={AdminModules.DEVICE}
                      actionName="View-Device"
                    >
                      <DMSDeviceComponent />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/admin/dms/device/:id"
                  element={
                    <PrivateRoute
                      moduleName={AdminModules.DEVICE}
                      actionName="View-Device"
                    >
                      <DMSDeviceDetailsComponent />
                    </PrivateRoute>
                  }
                />
              </Route>
              <Route
                path="/admin/dms/certificate"
                element={
                  <PrivateRoute
                    moduleName={AdminModules.CERTIFICATE}
                    actionName="View-Certificate"
                  >
                    <DMSCertificateComponent />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin/dms/ota"
                element={
                  <PrivateRoute
                    moduleName={AdminModules.OTA}
                    actionName="View-OTA"
                  >
                    <OTAComponent />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin/dms/sim"
                element={
                  <PrivateRoute
                    moduleName={AdminModules.SIM_CARD}
                    actionName="View-SIM Card"
                  >
                    <SimCardComponent />
                  </PrivateRoute>
                }
              />
            </Route>

            <Route
              path="/admin/configuration"
              element={
                <PrivateRoute
                  moduleName={AdminModules.CONFIGURATION}
                  actionName="View-Configuration"
                >
                  <ConfigurationComponent />
                </PrivateRoute>
              }
            >
              {/* <Route
                path="/admin/configuration/baseline"
                element={
                  <PrivateRoute
                    moduleName={AdminModules.BASELINE}
                    actionName="View-Baseline"
                  >
                    <BaselineComponent />
                  </PrivateRoute>
                }
              /> */}
              {/* <Route
                path="/admin/configuration/alertconfiguration"
                element={
                  <PrivateRoute
                    moduleName={AdminModules.ALERT_CONFIGURATION}
                    actionName="View-Alert Configuration"
                  >
                    <AlertConfigurationComponent />
                  </PrivateRoute>
                }
              /> */}
              <Route
                path="/admin/configuration/reportconfiguration"
                element={
                  <PrivateRoute
                    moduleName={AdminModules.REPORT_CONFIGURATION}
                    actionName="View-Report Configuration"
                  >
                    <ReportConfigurationComponent />
                  </PrivateRoute>
                }
              />
              {/* <Route
                path="/admin/configuration/masterconfiguration"
                element={
                  <PrivateRoute
                    moduleName={AdminModules.MASTER_CONFIGURATION}
                    actionName="View-Master Configuration"
                  >
                    <MasterConfigurationComponent />
                  </PrivateRoute>
                }
              /> */}
            </Route>
          </Route>

          <Route
            path="/profile"
            element={
              <PrivateRoute
                moduleName={UserModules.PROFILE}
                actionName="View-Profile"
              >
                <ProfilePageComponent />
              </PrivateRoute>
            }
          />

          {/* <Route path="/Example" element={<Example />} /> */}

          <Route
            path="/verify-master-data"
            element={(() => {
              // Set the redirect URL in local storage
              const currentUrl = window.location.href;
              const storedUrl = sessionStorage.getItem("currentUrl");
              const fullUrl = window.location.origin + `/verify-master-data`;

              if (storedUrl === fullUrl) {
                localStorage.setItem("postLoginRedirect", fullUrl);
              } else if (currentUrl === fullUrl) {
                // Save the current URL in session storage
                sessionStorage.setItem("currentUrl", currentUrl);
                localStorage.setItem("postLoginRedirect", fullUrl);
              }

              // Return the JSX element
              return (
                <PrivateRoute
                  moduleName={DashboardModules.DASHBOARD}
                  actionName="View-Dashboard"
                >
                  <CaseSensitiveRoute
                    path="/verify-master-data"
                    element={<VerifyMasterDataComponent />}
                  />
                </PrivateRoute>
              );
            })()}
          />
        </Route>
      </Routes>
    </>
  );
}
